import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { PanelContentContainer } from "~/OnboardingApp/components";
import { GetStartedCta } from "./GetStartedCta";
import { RAFHeading } from "./RAFHeading";
import { StepsConditional } from "./StepsConditional";

export const RightRAFSection: FC = () => {
  return (
    <PanelContentContainer>
      <Flex direction="column" gap={{ base: 0, lg: "6rem" }} w="full">
        <RAFHeading />
        <StepsConditional />
        <GetStartedCta />
      </Flex>
    </PanelContentContainer>
  );
};
